import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: '4px',
    marginRight: '-16px',
    padding: '0'
  },

  paper: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    width: 'auto',
    background: 'white'
  },

  list: {
    padding: '0'
  },

  option: {
    display: 'flex',
    alignItems: 'center'
  },

  item: {
    padding: 8
  },

  radio: {
    marginRight: '8px'
  },

  title: {
    marginBottom: '4px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  subTitle: {
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  }
}))

export default useStyles
